// assets/signature-founder.js

(function() {
  'use strict';

  function initSignatureForm() {
    const form = document.getElementById('signature-founder-form');
    if (!form) return;
    
    const submitBtn = form.querySelector('input[type="submit"]');
    const firstName = form.querySelector('input[name="first_name"]');
    const lastName = form.querySelector('input[name="last_name"]');
    const email = form.querySelector('input[name="email"]');
    const pickup = form.querySelector('select[name="pickup"]');
    const genre = form.querySelector('input[name="genre"]');
    
    // Real-time validation feedback
    if (firstName) {
      firstName.addEventListener('blur', function() {
        validateField(this);
      });
      firstName.addEventListener('input', function() {
        if (this.classList.contains('error')) {
          validateField(this);
        }
      });
    }
    
    if (lastName) {
      lastName.addEventListener('blur', function() {
        validateField(this);
      });
      lastName.addEventListener('input', function() {
        if (this.classList.contains('error')) {
          validateField(this);
        }
      });
    }
    
    if (email) {
      email.addEventListener('blur', function() {
        validateField(this);
      });
      email.addEventListener('input', function() {
        if (this.classList.contains('error')) {
          validateField(this);
        }
      });
    }
    
    if (pickup) {
      pickup.addEventListener('change', function() {
        validateField(this);
      });
    }
    
    if (genre) {
      genre.addEventListener('blur', function() {
        validateField(this);
      });
      genre.addEventListener('input', function() {
        if (this.classList.contains('error')) {
          validateField(this);
        }
      });
    }
    
    function validateField(field) {
      if (!field) return true;
      
      const errorEl = field.parentElement.querySelector('.field-error');
      
      // Remove existing error
      if (errorEl) {
        errorEl.remove();
      }
      field.classList.remove('error');
      
      // Validate based on field type
      let isValid = true;
      let errorMessage = '';
      
      if (field.type === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (field.value.trim() === '') {
          isValid = false;
          errorMessage = 'Email address is required';
        } else if (!emailRegex.test(field.value.trim())) {
          isValid = false;
          errorMessage = 'Please enter a valid email address';
        }
      } else if (field.tagName === 'SELECT') {
        if (!field.value || field.value === '') {
          isValid = false;
          errorMessage = 'Please select an option';
        }
      } else if (field.type === 'text' || field.type === 'text' || field.name === 'first_name' || field.name === 'last_name' || field.name === 'genre') {
        if (field.value.trim() === '') {
          isValid = false;
          errorMessage = 'This field is required';
        }
      }
      
      if (!isValid) {
        field.classList.add('error');
        const error = document.createElement('span');
        error.className = 'field-error';
        // error.style.cssText = 'color: #ff6b6b; font-size: 12px; display: block; margin-top: 4px;';
        error.textContent = errorMessage;
        field.parentElement.appendChild(error);
        return false;
      }
      
      return true;
    }
    
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      // Validate all fields
      const isFirstNameValid = validateField(firstName);
      const isLastNameValid = validateField(lastName);
      const isEmailValid = validateField(email);
      const isPickupValid = validateField(pickup);
      const isGenreValid = validateField(genre);
      
      if (!isFirstNameValid || !isLastNameValid || !isEmailValid || !isPickupValid || !isGenreValid) {
        // Scroll to first error
        const firstError = form.querySelector('.field-error');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      
      // Get form data
      const formData = new FormData(form);
      const data = {};
      formData.forEach((value, key) => {
        data[key] = value;
      });
      
      // Show submitting state
      const originalText = submitBtn.value;
      submitBtn.value = 'Submitting...';
      submitBtn.disabled = true;
      submitBtn.style.opacity = '0.7';
      
      // Simulate submission (replace with actual API call)
      setTimeout(function() {
        // Show success message
        const successMessage = document.createElement('div');
        successMessage.className = 'form-success';
        // successMessage.style.cssText = 'color: #51cf66; padding: 15px; background: rgba(81, 207, 102, 0.1); border-radius: 4px; margin-top: 15px; text-align: center;';
        successMessage.textContent = 'Thank you for your submission! You will be notified about the Signature Founders Run.';
        
        // Remove any existing success/error messages
        const existingSuccess = form.querySelector('.form-success');
        if (existingSuccess) existingSuccess.remove();
        const existingError = form.querySelector('.form-error');
        if (existingError) existingError.remove();
        
        form.appendChild(successMessage);
        
        // Reset form
        form.reset();
        
        // Reset submit button
        submitBtn.value = originalText;
        submitBtn.disabled = false;
        submitBtn.style.opacity = '1';
        
        // Remove field errors
        form.querySelectorAll('.field-error').forEach(el => el.remove());
        form.querySelectorAll('.error').forEach(el => el.classList.remove('error'));
        
        // Log data (for debugging)
        // console.log('Form Data:', data);
      }, 1000);
    });
  }

  // Initialize when DOM is ready
  function initialize() {
    initSignatureForm();
  }

  // Handle Shopify section reload (for theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target && event.target.querySelector('#signature-founder-form')) {
        setTimeout(initSignatureForm, 100);
      }
    });
    
    document.addEventListener('shopify:section:reorder', function(event) {
      if (event.target && event.target.querySelector('#signature-founder-form')) {
        setTimeout(initSignatureForm, 100);
      }
    });
  }

  // Listen for section updates via AJAX
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.detail ? event.detail.section : null;
    if (section && section.querySelector && section.querySelector('#signature-founder-form')) {
      setTimeout(initSignatureForm, 100);
    }
  });

  // Fallback: initialize when DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();